import cn from 'classnames';
import moment from 'moment';
import React, { useEffect, useReducer } from 'react';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { getOrientation } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

const TimePanel: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: { gameTitle: string; time: string }, newState: any) => ({ ...state, ...newState }), {
        gameTitle: '',
        time: ''
    });

    const orientation = useAppSelector(getOrientation);
    const classes = cn(styles.timePanel_container, orientation);

    useEffect(() => {
        setState({ gameTitle: ConfigLoader.getConfiguration(EConfigurationNames.GAME).gameTitle, time: moment(new Date()).format('HH:mm:ss') });
        setInterval(() => {
            setState({ time: moment(new Date()).format('HH:mm:ss') });
        }, 1000);
    }, []);

    return (
        <>
            {ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).timePanel && (
                <div className={classes}>
                    <div className={styles.timePanel}>{state.time}</div>
                </div>
            )}
        </>
    );
};

export default TimePanel;
